import script from "./TicketViewCommentForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketViewCommentForm.vue?vue&type=script&lang=ts&setup=true"

import "./TicketViewCommentForm.vue?vue&type=style&index=0&id=5c49c17b&scoped=true&lang=css"

import exportComponent from "/builds/nmhwyAssu/0/batesbus/app.securechannel.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c49c17b"]])

export default __exports__